import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space2, space4 } = theme();

  return StyleSheet.create({
    container: {
      display: "flex",
      flexDirection: "row",
      marginTop: space4,
    },
    icon: {
      marginRight: space2,
    },
  });
};

export { style };
